import { formatAmount } from "@utils";

// The default reminder subject/body, shared by the SendReminder modal and the Today's-tasks
// Preview so the preview shows exactly what Send will compose by default.
export const DEFAULT_REMINDER_SUBJECT = "Reminder for payment due";

export const buildDefaultReminderMessage = (paymentRequest) =>
  `We noticed a previous request for ${formatAmount(
    paymentRequest?.amountRequested,
  )} is still outstanding. You can complete the payment easily by clicking the link below. Thank you for your prompt attention. Should this payment have already been settled, please kindly disregard this reminder.`;
